import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import ScheduleScreen from './ScheduleScreen';
import OnboardingSteps from './OnboardingSteps';
import CheckCoverage from './CheckCoverage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Clarity from '@microsoft/clarity';
import LogRocket from 'logrocket';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';



function App() {
  const clarityId = process.env.REACT_APP_CLARITY_PROJECT_ID;
  const logRocketId = process.env.REACT_APP_LOGROCKET_PROJECT_ID;
  const metaPixelId = process.env.REACT_APP_META_PIXEL_ID;
  const ga4Id = process.env.REACT_APP_GA4_ID;

  useEffect(() => {
    if (clarityId && clarityId !== 'IGNORE') Clarity.init(clarityId);
    if (logRocketId && logRocketId !== 'IGNORE') LogRocket.init(logRocketId);

    if (metaPixelId && metaPixelId !== 'IGNORE') {
      ReactPixel.init(metaPixelId);
      ReactPixel.trackCustom('NewLead');
    }

    if (ga4Id && ga4Id !== "IGNORE") {
      ReactGA.initialize(ga4Id);
      ReactGA.event({
        category: 'User Interaction',
        action: 'Viewed',
        label: 'Schedule',
      });
    }
  }, [clarityId, logRocketId, metaPixelId, ga4Id]);


  return (
    <>
      <BrowserRouter>
        <a href="#main-content" className="skip-link">Skip to main content</a>
        <Header />
        <main id="main-content" tabIndex="-1">
          <Routes>
            <Route path="/check-coverage" element={<CheckCoverage />} />
            <Route
              path="*"
              element={
                <>
                  <OnboardingSteps />
                  <ScheduleScreen />
                </>
              }
            />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;